<template>
  <div id="edit-signatur-view">
    <h1 class="fs-2 mb-0" v-if="signatur != null">Signatur bearbeiten</h1>
    <h1 class="fs-2 mb-0" v-else>Neue Signatur</h1>

    <LoadingSpinner v-if="loading" />

    <div v-else>
      <form @submit.prevent="saveSignatur">
        <div class="row mx-0">
          <div class="col-4 p-2 ps-0">
            <div class="bg-white shadow rounded p-3 pe-4 h-100">
              <div class="mb-3">
                <label for="unterschrift" class="form-label">Unterschrift/Name</label>
                <input type="text" class="form-control" id="unterschrift" v-model="editSignatur.unterschrift" />
              </div>

              <div class="mb-3">
                <label for="zeichnung" class="form-label">Zeichnung</label>
                <input type="text" class="form-control" id="zeichnung" v-model="editSignatur.zeichnung" />
              </div>

              <div class="mb-3">
                <label for="funktion" class="form-label">Funktion</label>
                <input type="text" class="form-control" id="funktion" v-model="editSignatur.funktion" />
              </div>

              <div class="mb-3">
                <label for="funktionEN" class="form-label">Funktion EN</label>
                <input type="text" class="form-control" id="funktionEN" v-model="editSignatur.funktionEN" />
              </div>
            </div>
          </div>
        </div>

        <div v-if="errorMsg != ''" class="alert alert-danger">
          Es ist ein Fehler aufgetreten:
          {{ errorMsg }}
        </div>

        <div class="save-bar bg-white position-fixed bottom-0 end-0 p-3 w-100 shadow border-top d-flex justify-content-end">
          <button type="button" class="btn btn-secondary me-3" @click="cancel()">Abbrechen</button>
          <button type="submit" class="btn btn-primary">Speichern</button>
        </div>
      </form>

      <div v-if="signatur != null">
        <button type="button" class="btn btn-danger" @click="deleteSignatur()"><font-awesome-icon icon="trash" /> Signatur löschen</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, ref, PropType } from 'vue';
  import { useStore } from '@/store';
  import { useRouter } from 'vue-router';

  import { ActionTypes as VertragspartnerActionTypes } from '@/store/modules/Vertragspartner/actions';

  import { Signatur } from '@/models/VertragspartnerModels';

  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  //#endregion

  const props = defineProps({
    signaturid: {
      type: String as PropType<string>,
      default: '',
    },
  });

  const store = useStore();
  const router = useRouter();

  const loading = computed(
    () => store.getters.status.createSignaturLoading || store.getters.status.updateSignaturLoading || store.getters.status.deleteSignaturLoading
  );
  const errorMsg = computed(() => store.getters.status.signaturErrorMsg);

  const signatur = computed(() => store.getters.signaturen.find((v: Signatur) => v.id == parseInt(props.signaturid)));
  const editSignatur = ref(signatur.value != null ? (JSON.parse(JSON.stringify(signatur.value)) as Signatur) : new Signatur());

  function saveSignatur() {
    if (signatur.value != null) {
      store.dispatch(VertragspartnerActionTypes.UpdateSignatur, editSignatur.value).then(() => {
        if (errorMsg.value == '') {
          router.push({ name: 'DetailsSignatur', query: { signaturid: props.signaturid } });
        }
      });
    } else {
      store.dispatch(VertragspartnerActionTypes.CreateSignatur, editSignatur.value).then(() => {
        if (errorMsg.value == '') {
          router.push({ name: 'Signaturen' });
        }
      });
    }
  }

  function deleteSignatur() {
    if (signatur.value != null) {
      store.dispatch(VertragspartnerActionTypes.DeleteSignatur, signatur.value.id).then(() => {
        if (errorMsg.value == '') {
          router.push({ name: 'Signaturen' });
        }
      });
    }
  }

  function cancel() {
    router.back();
  }
</script>

<style scoped>
  .save-bar {
    z-index: 1;
  }

  #edit-vertragspartner-view {
    margin-bottom: 70px;
  }
</style>
